import { graphql } from '../__generated__/gql';

export const GET_ALL_MC1S = graphql(/* GraphQL */ `
  query MC1s($assetId: Int!) {
    allMC1s(assetId: $assetId) {
      mc1Id
      mc1Number
      mediaUrl
      assetId
      createdBy
      updatedAt
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_MC1 = graphql(/* GraphQL */ `
  mutation CreateMC1($input: MC1Input!) {
    createMC1(input: $input) {
      mc1Id
      mc1Number
      assetId
    }
  }
`);
